interface Ilocus {
  id?: string;
  type?: string;
  cityCode?: string;
}

export const getLocusUrlParam = (locus, isStartUrl = false) => {
  const urlParams = {};
  if (!locus) {
    return urlParams;
  }

  const {id, type, cityCode}: Ilocus = locus;

  if (id && type) {
    urlParams.locusId = id;
    urlParams.locusType = type;
  }
  if (cityCode) {
    urlParams.cityCode = cityCode;
  }

  return urlParams;
};

/**
 *
 * @param param0 accept locus code and type
 * @returns base on param0 return
 */

const getLocusUrlString = (locus, isStartUrl = false) => {
  if (!locus) {
    return '';
  }

  const {id, type, cityCode}: Ilocus = locus;
  let locusUrl = isStartUrl ? '?' : '&';
  if (id && type) {
    locusUrl += `locusId=${id}&locusType=${type}`;
  }
  if (cityCode) {
    locusUrl += `&cityCode=${cityCode}`;
  }
  return locusUrl;
};

export default getLocusUrlString;
